import React from "react";
import { imageCodes, textCodes, titleCodes } from "../../template_codes/vcare/about_page_codes";

function About() {
    return (
        <div className="container w-full md:w-4/5 lg:w-3/6 xl:w-3/6 2xl:w-3/6">
            <div className="flex gap-x-2 md:gap-x-16 lg:gap-x-16 xl:gap-x-16 2xl:gap-x-16">
                <img src={imageCodes.vMen.image} className="w-24 h-72 md:w-32 md:h-80 lg:w-32 lg:h-80 xl:w-32 xl:h-80 2xl:w-32 2xl:h-80"></img>
                <div className="mt-8 text-center">
                    <h1 className="text-xl font-semibold pb-4">{titleCodes.aboutVcare.title}</h1>
                    <p className="leading-loose text-justify">{textCodes.aboutUs.text}</p>
                </div>
                <img src={imageCodes.vGirl.image} className="w-24 h-72 md:w-32 md:h-80 lg:w-32 lg:h-80 xl:w-32 xl:h-80 2xl:w-32 2xl:h-80"></img>
            </div>
        </div>
    );
}

export default About;